import React from "react";
import { Box, MenuItem, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PropTypes } from "prop-types";
import { courseStatuses } from "../../../../constants/index";

const StatusFilter = ({ onChange, defaultValue }) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" flex={1} alignItems="center">
      <Typography variant="h6" sx={{ mr: 3 }}>
        {t("manageCourses.statusFilterLabel")}
      </Typography>
      <Box minWidth={190}>
        <TextField
          select
          defaultValue={defaultValue}
          onChange={ev => onChange(ev.target.value)}
          variant="filled"
          InputProps={{
            disableUnderline: true,
            inputProps: {
              "data-qa": "status-filter-input"
            }
          }}
          SelectProps={{
            SelectDisplayProps: { "data-qa": "status-filter-select" }
          }}
          fullWidth
          hiddenLabel
        >
          {courseStatuses.map(({ id, label }) => (
            <MenuItem value={id} key={id}>
              {t(label)}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    </Box>
  );
};

export default StatusFilter;

StatusFilter.propTypes = {
  onChange: PropTypes.func,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
